import { ArrayValue, BooleanValue, NumberValue, RecordValue, StringValue, Value, } from '@coveo/bueno';
import { createAction } from '@reduxjs/toolkit';
import { requiredNonEmptyString, serializeSchemaValidationError, validatePayload, validatePayloadAndThrow, } from '../../../utils/validate-payload.js';
import { facetIdDefinition } from '../generic/facet-actions-validation.js';
import { validateCategoryFacetValue } from './category-facet-validate-payload.js';
const categoryFacetPayloadDefinition = {
    facetId: facetIdDefinition,
    field: requiredNonEmptyString,
    tabs: new RecordValue({
        options: {
            required: false,
        },
        values: {
            included: new ArrayValue({ each: new StringValue() }),
            excluded: new ArrayValue({ each: new StringValue() }),
        },
    }),
    activeTab: new StringValue({ required: false }),
    delimitingCharacter: new StringValue({ required: false, emptyAllowed: true }),
    filterFacetCount: new BooleanValue({ required: false }),
    injectionDepth: new NumberValue({ required: false, min: 0 }),
    numberOfValues: new NumberValue({ required: false, min: 1 }),
    sortCriteria: new Value({ required: false }),
    basePath: new ArrayValue({ required: false, each: requiredNonEmptyString }),
    filterByBasePath: new BooleanValue({ required: false }),
};
export const defaultNumberOfValuesIncrement = 5;
export const registerCategoryFacet = createAction('categoryFacet/register', (payload) => validatePayload(payload, categoryFacetPayloadDefinition));
export const toggleSelectCategoryFacetValue = createAction('categoryFacet/toggleSelectValue', (payload) => {
    try {
        validatePayloadAndThrow(payload.facetId, requiredNonEmptyString);
        validateCategoryFacetValue(payload.selection);
        return { payload, error: null };
    }
    catch (error) {
        return { payload, error: serializeSchemaValidationError(error) };
    }
});
export const deselectAllCategoryFacetValues = createAction('categoryFacet/deselectAll', (payload) => validatePayload(payload, categoryFacetPayloadDefinition.facetId));
export const updateCategoryFacetNumberOfValues = createAction('categoryFacet/updateNumberOfValues', (payload) => validatePayload(payload, {
    facetId: categoryFacetPayloadDefinition.facetId,
    numberOfValues: categoryFacetPayloadDefinition.numberOfValues,
}));
export const updateCategoryFacetSortCriterion = createAction('categoryFacet/updateSortCriterion', (payload) => validatePayload(payload, {
    facetId: categoryFacetPayloadDefinition.facetId,
    criterion: new Value(),
}));
export const updateCategoryFacetBasePath = createAction('categoryFacet/updateBasePath', (payload) => validatePayload(payload, {
    facetId: categoryFacetPayloadDefinition.facetId,
    basePath: new ArrayValue({ each: requiredNonEmptyString }),
}));
